import { allPosts, Post } from '@/mocks/allPosts';

// Posts publish at 08:00, 13:00, 19:00 every day
// Day 0 = the "epoch" start date (Jan 1, 2025)
const EPOCH = new Date('2025-01-01T00:00:00');
const PUBLISH_HOURS = [8, 13, 19]; // 3 posts per day

function getPublishDateTime(publishIndex: number): Date {
  const dayIndex = Math.floor(publishIndex / 3);
  const slotIndex = publishIndex % 3;
  const date = new Date(EPOCH);
  date.setDate(date.getDate() + dayIndex);
  date.setHours(PUBLISH_HOURS[slotIndex], 0, 0, 0);
  return date;
}

export function getPublishedPosts(): Post[] {
  const now = new Date();
  return allPosts
    .filter((post) => getPublishDateTime(post.publishIndex) <= now)
    .sort((a, b) => b.publishIndex - a.publishIndex);
}

export function getPostPublishDate(post: Post): Date {
  return getPublishDateTime(post.publishIndex);
}

export function formatPublishDate(date: Date): string {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function getRelatedPosts(currentPost: Post, count = 3): Post[] {
  const published = getPublishedPosts();
  return published
    .filter((p) => p.id !== currentPost.id && p.category === currentPost.category)
    .slice(0, count);
}

export function getTodaysPosts(): Post[] {
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  return allPosts.filter((post) => {
    const pub = getPublishDateTime(post.publishIndex);
    return pub >= todayStart && pub <= todayEnd;
  });
}

export function getScheduledPosts(daysAhead = 7): Array<{ post: Post; publishAt: Date }> {
  const now = new Date();
  return allPosts
    .map((post) => ({ post, publishAt: getPublishDateTime(post.publishIndex) }))
    .filter(({ publishAt }) => publishAt > now)
    .slice(0, daysAhead * 3);
}

export interface NextPublishInfo {
  date: Date;
  slotLabel: string;
  isToday: boolean;
  isTomorrow: boolean;
}

export function getNextPublishTime(): NextPublishInfo | null {
  const now = new Date();
  const totalPublished = allPosts.filter(
    (p) => getPublishDateTime(p.publishIndex) <= now
  ).length;

  const nextIndex = totalPublished;
  if (nextIndex >= allPosts.length) return null;

  const date = getPublishDateTime(nextIndex);
  const slotIndex = nextIndex % 3;
  const slotLabels = ['Morning', 'Afternoon', 'Evening'];

  const nowDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const pubDay = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  const diffDays = Math.round((pubDay - nowDay) / 86400000);

  return {
    date,
    slotLabel: slotLabels[slotIndex],
    isToday: diffDays === 0,
    isTomorrow: diffDays === 1,
  };
}
